var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('BannerStatic',{attrs:{"ban":_vm.banner}}),_c('NewsDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }